import React from 'react';

const Modal = ({ text, btntext, hide }) => (
    <div className="modal">
        <div className="modal__inner">
            <p>
                {text}
            </p>
            <a className="button" onClick={() => hide() }>{btntext}</a>
        </div>
    </div>
);

export default Modal;